import React from 'react';
import { useMutation } from 'react-apollo';
import { notification } from 'antd';
import CREATE_FRICTIONLESS_PR from '../../../GraphQl/Mutations/CREATE_FRICTIONLESS_PR';

const TagsManagerController = ({
  orgs,
  currentOrgId,
  createEventTag,
  carts,
  detectCart,
  cartDetectionData,
  cartDetectionLoading,
  currentUser,
  ...props
}) => {

  const [createFrictionlessPRMutation] = useMutation(CREATE_FRICTIONLESS_PR);

  const advertisers = orgs.orgs.map((org) => {
    return { value: org.id, label: org.name };
  });

  const onSubmit = async (values) => {
    try {
       const result = await createEventTag({
        variables: {
          data: {
            name: values.name,
            orgId: values.advertiser,
            isEcommerce: values.ecommerce,
            cart: values.platform,
            isSignUps: values.signups,
            domain: values.domain,
            appId: values.appId,
            dspTracking: values.dspTracking,
            orgAdvertiserId: values.orgAdvertiserId,
            s3_pv: values.s3_pv,
            s3_tr: values.s3_tr,
            thirdPartyTag: values.thirdPartyTag,
          },
        },
      });

      console.log("values: ", values);

       if (values.dspTracking && values.s3_pv && values.s3_tr && values.appId) {
        const selectedOrg = orgs.orgs.find((org) => org.id === values.advertiser);
        const orgDomain = selectedOrg && selectedOrg.domain;

        if (orgDomain) {
          try {
            const prResult = await createFrictionlessPRMutation({
              variables: {
                data: {
                  domain: orgDomain,
                  appId: values.appId,
                  s3_pv: values.s3_pv,
                  s3_tr: values.s3_tr,
                  dspTracking: values.dspTracking,
                  isUpdate: false,
                },
              },
            });

            if (prResult?.data?.createFrictionlessPR?.prUrl) {
              console.log(`Frictionless PR created successfully: ${prResult.data.createFrictionlessPR.prUrl}`);
            }
          } catch (prError) {
            console.error('Error creating frictionless PR:', prError);
          }
        } else {
          console.warn('Org domain not found, skipping frictionless PR creation');
          notification.warning({
            message: 'Advertiser Domain Required',
            description: 'Advertiser Domain should be configured and added when s3_pv and s3_tr are provided',
            duration: 6,
          });
        }
      } else {
        console.log('Frictionless PR conditions not met. Skipping PR creation.');
      }

      return result;

    } catch (error) {
      console.error('Error creating event tag:', error);
       throw error;
    }
  };

  return React.cloneElement(props.children, {
    ...props.children.props,
    advertisers,
    currentOrgId,
    carts: carts.getCarts,
    onSubmit,
    detectCart,
    cartDetectionData,
    cartDetectionLoading,
    orgs,
    currentUser,
  });
};

export default TagsManagerController;
